import { createStore, applyMiddleware } from 'redux';
import settlementReducer from '../reducers/settlementReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(settlementReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
